<template>
  <v-container fluid>
    <v-data-table v-model="selected" show-select class="pt-3" flat :headers="Avenantheaders" :items="ContractsList"
      :items-per-page="5" :loading="loading ? '#0482fb' : null" sort-by="" item-key="_id">
      <template v-slot:top>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date encaissement début ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="startDate" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date encaissement fin ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="endDate" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined :items="userFile" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                      v-model="fileName" dense flat background-color="grey lighten-4" label="Nom / Raison Sociale ...">
                    </v-autocomplete>
                    <!-- <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="fileName" flat
                      background-color="grey lighten-4"></v-text-field> -->
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Police ..." class="pt-5 pa-2"
                      v-model="policeNumber" prepend-inner-icon="mdi-magnify" dense flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date encaissement prime début ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="primeRepaymentDateStart" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date encaissement prime fin ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="primeRepaymentEndDate" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Avenant ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="plugged" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro Quittance ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="receiptNumber" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="company" flat background-color="grey lighten-4" label="Compagnie ..."></v-select></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date reverssement prime début ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="companyRepaymentStartDate" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="Date reverssement prime fin ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="date" v-model="companyRepaymentEndDate" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="items" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="paymentMethod" flat background-color="grey lighten-4"
                      label="Mode de paiement"></v-select></v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Montant prime nette..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense type="number" v-model="netPrimeSearch" flat
                      background-color="grey lighten-4"></v-text-field></v-col>
                </v-row>
                <v-card-actions>
                  <v-btn class="red--text mr-2" outlined color="red" pill @click="cleanOnEnter">

                    Effacer
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
        <v-toolbar flat>
          <h4 class="text-h4 pageTitle ">Liste des paiements</h4>
          <v-divider class="mx-4" inset vertical></v-divider>
          <h4 class="text-h4 pageTitle">{{ selected.length ? selected.length : 0 }} sélections</h4>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb" @change="showAllFillData"
            class="pt-5"></v-switch>
        </v-toolbar>
        <v-btn color="#0482fb" dark class="mt-5 ml-5 mb-10" @click="applyEncaissementModal()">
          Payement commission
        </v-btn>
      </template>
      <template v-slot:item.name="{ item }">
        <td>
          {{ item.file.name }}
        </td>
      </template>

      <template v-slot:item.company="{ item }">
        <td>
          {{ item.company && item.company.name ? item.company.name : "" }}
        </td>
      </template>
      <template v-slot:item.collectionDate="{ item }">
        <td>
          {{ getMonthNameFromDate(item.collectionDate) }}
        </td>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu elevation="0" right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
              <v-icon color="success" size="30">mdi-forwardburger</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="editContractCollection(item)" v-bind="attrs" v-on="on"
                    color="warning">mdi-pencil-box-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Modification du contrat sélectionné</span>
            </v-tooltip>
            <!-- <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" color="success" v-bind="attrs" v-on="on" @click="editFactureCollection(item)">
                    mdi-receipt-text-plus</v-icon>
                </v-btn>
              </template>
              <span>Encaissement de la commission</span>
            </v-tooltip> -->
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGedQuitance(item)" color="success" v-bind="attrs" v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers quittance </span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGed(item)" color="success" v-bind="attrs" v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers reversement </span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGedPayement(item)" color="success" v-bind="attrs" v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Gestion des fichiers paiement </span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon size="20" @click="handleClickMailGedPayementPreuve(item)" color="success" v-bind="attrs"
                    v-on="on">
                    mdi-file-document-multiple-outline</v-icon>
                </v-btn>
              </template>
              <span>Autres preuve</span>
            </v-tooltip>
          </v-list>
        </v-menu>
      </template>

    </v-data-table>
    <v-dialog v-model="addFileMailGedQuittance" max-width="900px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
            Quittance</span>
        </v-card-title>
        <v-item-group multiple>
          <v-container>
            <!-- {{filesListe}} -->
            <v-row>
              <v-col v-for="n in filesListeQuitance" :key="n" cols="12" md="4">
                <v-item>
                  <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                    <v-card-text style="height: 100px; position: relative">
                      <h4 style="text-align: center;">
                        {{ n.filename }}
                      </h4>
                      <v-fab-transition>
                        <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                          route bottom right fab>
                          <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addFileMailGed" max-width="900px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
            reversement</span>
        </v-card-title>
        <v-item-group multiple>
          <v-container>
            <!-- {{filesListe}} -->
            <v-row>
              <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                <v-item>
                  <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                    <v-card-text style="height: 100px; position: relative">
                      <h4 style="text-align: center;">
                        {{ n.filename }}
                      </h4>
                      <v-fab-transition>
                        <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                          route bottom right fab>
                          <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addFileMailGedPayement" max-width="900px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
            paiement</span>
        </v-card-title>
        <v-item-group multiple>
          <v-container>
            <!-- {{filesListe}} -->
            <v-row>
              <v-col v-for="n in filesListePayement" :key="n" cols="12" md="4">
                <v-item>
                  <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                    <v-card-text style="height: 100px; position: relative">
                      <h4 style="text-align: center;">
                        {{ n.filename }}
                      </h4>
                      <v-fab-transition>
                        <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                          route bottom right fab>
                          <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addFileMailGedPayementPreuveData" max-width="900px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
            paiement</span>
        </v-card-title>
        <v-item-group multiple>
          <v-container>
            <!-- {{filesListe}} -->
            <v-row>
              <v-col v-for="n in filesListePayementPreuve" :key="n" cols="12" md="4">
                <v-item>
                  <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                    <v-card-text style="height: 100px; position: relative">
                      <h4 style="text-align: center;">
                        {{ n.filename }}
                      </h4>
                      <v-fab-transition>
                        <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                          route bottom right fab>
                          <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card>
    </v-dialog>
    <!-- facture dialoge-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="factureDialog" max-width="500px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h5">Générer une facture</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.netPrime" label="Prime nette"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.totalPrime" label="Prime Total"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.commission" label="Commission"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.cdeaoPrime" label="TAXE"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.TACAVA" label="FGA"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.TVA" label="CEDEAO"
                      type="number"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="white--text ma-2" color="error " text @click="closeContract">
                Fermer
              </v-btn>
              <v-btn color="success " :loading="loading ? '#0482fb' : null" class="ml-5" @click="invoiceAdd">
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-dialog transition="dialog-bottom-transition" max-width="800" overlay v-model="cancelDialog">
      <v-card style="border-top:10px solid red">
        <v-card-title>
          <span class="text-h5 mb-5 mt-5" style="color:#3A1C71;">Payement commission des dossiers
            sélectionnés</span>
        </v-card-title>
        <v-card-text>
          <v-row>

            <v-col cols="12" md="6">
              <v-text-field outlined color="#0482fb" type="date" background-color="#cbf3f0" label="Date d'encaissement"
                v-model="contractModal.collectionDate"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0" label="Numéro courrier arrivé (preuve)"
                v-model="contractModal.mailNumberOtherFile"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete outlined :items="itemsPayment" background-color="#cbf3f0" color="#0482fb"
                label="Mode de paiement" v-model="contractModal.paymentPaymentMethod"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0" v-model="contractModal.paymentCheckNumber"
                label="Numéro chèque"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete outlined :items="itemsBank" background-color="#cbf3f0" color="#0482fb" label="Banque"
                v-model="contractModal.paymentBank"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn>
          <v-btn color="error" class="white--text" @click="innCash()">Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Encaissement dialoge-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="contractDialog" max-width="1000px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h5">Rapprochement encaissement</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" disabled v-model="contractModal.name"
                      label="Nom / Raison sociale"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" disabled v-model="contractModal.company"
                      label="Compagnie"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" label="N° Police"
                      v-model="contractModal.policeNumber"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" disabled v-model="contractModal.receiptNumber"
                      label="N° quittances"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" disabled v-model="contractModal.product"
                      label="Branches"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" disabled v-model="contractModal.category"
                      label="Catégorie"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.effectDate" type="date"
                      label="Date effet"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.dueDate" label="Date échéances"
                      type="date"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.netPrime" label="Prime nette DAYO"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.commission" label="Commission DAYO"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.totalPrime" label="Prime TTC"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.primeRC" label="Prime RC"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.cdeaoPrime" label="TAXE"
                      type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.companyNetPrime"
                      label="Prime nette compagnie" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.companyCommission"
                      label="Commission compagnie" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined color="#0482fb" v-model="contractModal.collectionDate" type="date"
                      label="Date paiement commission"></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" md="3">
                    <v-select outlined :items="items" color="#0482fb" label="Mode de paiement"
                      v-model="contractModal.paymentMethod"></v-select>
                  </v-col> -->
                  <v-col cols="12" md="4">
                    <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                      label="Numéro courrier arrivé (preuve)" v-model="contractModal.mailNumberOtherFile"></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field color="#0482fb" disabled v-model="contractModal.emissionNumber" label="Numéro émission"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field color="#0482fb" v-model="contractModal.commissionSlipNumber" label="Numéro facture"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete outlined :items="itemsPayment" background-color="#cbf3f0" color="#0482fb"
                      label="Mode de paiement" v-model="contractModal.paymentPaymentMethod"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                      v-model="contractModal.paymentCheckNumber" label="Numéro chèque"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete outlined :items="itemsBank" background-color="#cbf3f0" color="#0482fb" label="Banque"
                      v-model="contractModal.paymentBank"></v-autocomplete>
                  </v-col>
                  <!-- <v-col cols="12" md="3">
                    <v-text-field outlined  
            color="#0482fb"
                      v-model="contractModal.variationNetPrime"
                      label="Variation prime nette"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
            color="#0482fb"
                      v-model="contractModal.variationCommission"
                      label="Variation commission"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <br /> -->
                  <!-- <v-col cols="12" md="6" sm="6">
                    <v-textarea outlined v-model="contractModal.netPrimeObservation" name="input-7-4" rows="2"
                      label="Observation prime nette"></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea outlined v-model="contractModal.commissionObservation" name="input-7-4" rows="2"
                      label="Observation commission"></v-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-textarea outlined v-model="contractModal.transferObservation" name="input-7-4" rows="2"
                      label="Observation reversement"></v-textarea>
                  </v-col> -->
                  <v-col cols="12" md="12">
                    <v-textarea outlined v-model="contractModal.paymentObservation" name="input-7-4" rows="2"
                      label="Observation paiement COM"></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error " text @click="closeContract">
                Fermer
              </v-btn>
              <v-btn color="success " :loading="loading ? '#0482fb' : null" class="ml-5" @click="cashIn">
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addFileMailGedQuittance" max-width="900px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
                Quittance</span>
            </v-card-title>
            <v-item-group multiple>
              <v-container>
                <!-- {{filesListe}} -->
                <v-row>
                  <v-col v-for="n in filesListeQuitance" :key="n" cols="12" md="4">
                    <v-item>
                      <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                        <v-card-text style="height: 100px; position: relative">
                          <h4 style="text-align: center;">
                            {{ n.filename }}
                          </h4>
                          <v-fab-transition>
                            <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                              route bottom right fab>
                              <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                            </v-btn>
                          </v-fab-transition>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addFileMailGed" max-width="900px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
                reversement</span>
            </v-card-title>
            <v-item-group multiple>
              <v-container>
                <!-- {{filesListe}} -->
                <v-row>
                  <v-col v-for="n in filesListe" :key="n" cols="12" md="4">
                    <v-item>
                      <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                        <v-card-text style="height: 100px; position: relative">
                          <h4 style="text-align: center;">
                            {{ n.filename }}
                          </h4>
                          <v-fab-transition>
                            <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                              route bottom right fab>
                              <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                            </v-btn>
                          </v-fab-transition>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addFileMailGedPayement" max-width="900px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
                paiement</span>
            </v-card-title>
            <v-item-group multiple>
              <v-container>
                <!-- {{filesListe}} -->
                <v-row>
                  <v-col v-for="n in filesListePayement" :key="n" cols="12" md="4">
                    <v-item>
                      <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                        <v-card-text style="height: 100px; position: relative">
                          <h4 style="text-align: center;">
                            {{ n.filename }}
                          </h4>
                          <v-fab-transition>
                            <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                              route bottom right fab>
                              <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                            </v-btn>
                          </v-fab-transition>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addFileMailGedPayementPreuve" max-width="900px">
          <v-card style="border-top: 10px solid #0482fb">
            <v-card-title>
              <span class="text-h4  mb-5 mt-5" style="color:#0482fb;font-weight: bold;">Gestionnaire de fichier
                paiement</span>
            </v-card-title>
            <v-item-group multiple>
              <v-container>
                <!-- {{filesListe}} -->
                <v-row>
                  <v-col v-for="n in filesListePayement" :key="n" cols="12" md="4">
                    <v-item>
                      <v-card style="border: 2px solid #0482fb" class="d-flex align-center" height="250">
                        <v-card-text style="height: 100px; position: relative">
                          <h4 style="text-align: center;">
                            {{ n.filename }}
                          </h4>
                          <v-fab-transition>
                            <v-btn class="white--text  mt-10" color="#0482fb" :href="n.path" target="_blank" dark absolute
                              route bottom right fab>
                              <v-icon target="_blank" route :href="n.path">mdi-download</v-icon>
                            </v-btn>
                          </v-fab-transition>
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages, rules } from "@/utils/data";
import { addFile, updateFile } from "@/api/admin";

import { updateContract, addInvoice } from "@/api/user";
export default {
  name: "production",
  components: {},
  data: () => ({
    panel: [],
    switch1: true,
    tab: null,
    perssonel: [],
    items: ["Espèces", "Chèque", "Virement", "Avoir"],
    natureprospect: ["Physics", "Entreprise"],
    focus: "",
    events: [],
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    addFileMailGed: false,
    filesListe: [],
    filesListeQuitance: [],
    filesListePayement: [],
    cancelDialog: false,
    filesListePayementPreuve: [],
    addFileMailGedPayementPreuve: false,
    addFileMailGedPayementPreuveData: false,
    addFileMailGedQuittance: false,
    addFileMailGedPayement: false,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    colors: ["red"],
    names: ["Appel"],
    colorss: ["green"],
    namess: ["Rendez vous"],
    categories: ["John Smith"],
    addgarantie: false,
    dialog: false,
    fileDialog: false,
    contractDialog: false,
    appels: false,
    newappel: false,
    rdv: false,
    selected: {},
    linkFacture: false,
    produit: false,
    cotation: false,
    garantie: false,
    contrat: false,
    notifications: false,
    sound: true,
    widgets: false,
    factureDialog: false,
    itemsPayment: ["Espèces", "Chèque", "Virement", "Avoir"],
    itemsBank: [
      "BANQUE INTERNATIONALE POUR L’INDUSTRIE ET LE COMMERCE (BIIC)",
      "BANK Of AFRICA (BOA)",
      "ORABANK BENIN (OBB)",
      "ECOBANK BENIN (EBB)",
      "NSIA BANQUE",
      "SOCIETE GENERALE du BENIN (SGB)",
      "BANQUE SAHELO-SAHARIENNE POUR L’INVESTISSEMENTEMENT ET LE COMMERCE (BSIC-BENIN)",
      "BANQUE ATLANTIQUE AU BENIN (BAB)",
      "BGFIBANK BENIN",
      "UNITED BANK FOR AFRICA (UBA)",
      "CCEI BANK BENIN Afriland First Group",
      "CBAO BENIN Groupe Attijariwafa Bank",
      "CORIS BANK INTERNATIONAL (CBI)",
      "SOCIÉTÉ NIGÉRIENNE DE BANQUE (SONIBANK)",
      "TRESOR PUBLIC",
      "BANGE BANK BENIN"
    ],
    prospect: false,
    dialogDelete: false,

    Avenantheaders: [
      {
        text: "Actions",
        value: "actions",
        width: "150px",
        align: "left",
        sortable: false,
      },
      // {
      //   text: "id",
      //   width: "200px",
      //   // align: "start",
      //   value: "_id",
      // },
      // { text: "Status", width: "200px", value: "status" },
      {
        text: "Date Encaissement",
        width: "200px",
        align: "start",
        sortable: false,
        value: "primeRepaymentDate",
      },
      {
        text: "Date Reversement",
        width: "200px",
        align: "start",
        sortable: false,
        value: "companyRepaymentDate",
      },
      { text: "Mois de payement", width: "200px", value: "collectionDate" },
      { text: "Nom / Raison sociale", width: "200px", value: "name" },
      { text: "Compagnie", width: "200px", value: "company" },
      { text: "N° Police", width: "200px", value: "policeNumber" },
      { text: "N° quitances", width: "200px", value: "receiptNumber" },
      { text: "N° Avenant", width: "200px", value: "plugged" },
      { text: "Branches", width: "200px", value: "product" },
      { text: "Catégorie", width: "200px", value: "category" },
      { text: "Date effet", width: "200px", value: "effectDateFr" },
      { text: "Date échéance", width: "200px", value: "dueDateFr" },
      { text: "Date encaissement", width: "200px", value: "paymentDateFr" },
      { text: "Prime nette DAYO", width: "200px", value: "netPrime" },
      { text: "Commission DAYO", width: "200px", value: "commission" },
      { text: "Taux de commision", width: "200px", value: "commissionRate" },
      { text: "Mode de paiement", width: "200px", value: "paymentMethod" },
      { text: "Prime TTC", width: "200px", value: "totalPrime" },
      { text: "Accessoire", width: "200px", value: "accessory100" },
      { text: "Date paiement", width: "200px", value: "collectionDateFr" },
      {
        text: "Prime nette compagnie",
        width: "200px",
        value: "companyNetPrime",
      },
      {
        text: "Commission compagnie",
        width: "200px",
        value: "companyCommission",
      },
      {
        text: "Variation prime nette",
        width: "200px",
        value: "variationNetPrime",
      },
      {
        text: "Variation commission",
        width: "200px",
        value: "variationCommission",
      },
      {
        text: "Observation prime nette",
        width: "200px",
        value: "netPrimeObservation",
      },
      {
        text: "Observation commission",
        width: "200px",
        value: "commissionObservation",
      },
      {
        text: "Observation reversement",
        width: "200px",
        value: "transferObservation",
      },
      {
        text: "Observation paiement",
        width: "200px",
        value: "paymentObservation",
      },
    ],
    produittake: [
      {
        text: "Liste des produits Proposer",
        value: "nom",
      },
    ],
    headers: [
      {
        text: "Nom / Raison sociale",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Nature", value: "nature" },
      // { text: "Description", value: "description" },
      { text: "Activité", value: "activityField" },
      { text: "Mail", value: "email" },
      { text: "Phone", value: "phone" },
      { text: "Date d'aniversaire", value: "birthday" },
      { text: "Localisation", value: "location" },
    ],
    listproduit: [
      {
        name: "Cart d'identité",
      },
      {
        name: "permis de conduit",
      },
      {
        name: "Atestation de residence",
      },
    ],
    prospectdata: [],
    productNameList: [],
    editedIndex: -1,
    contractModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      prospects: [],
    },
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    rules,
    avenantList: [
      "Affaire Nouvelle",
      "Renouvellement",
      "Incorporation",
      "Retrait",
      "Suspension",
      "Remise en vigeur",
      "Precision",
      "Modification",
      "Resiliation",
      "Régularisation",
      "Changement d'immatriculation",
    ],
    companyNameList: [],
  }),

  mounted() {
    this.initContracts();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters(["ContractsList", "Companies", "Products", "Files"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter Dossier Production"
        : "Modifier Dossier Production ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
      // this.seedCoinsuranceCompanyNameList();
    },
    Products() {
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    selected() {
      localStorage.setItem("payementSelectData", JSON.stringify(this.selected));
      // alert(JSON.stringify())
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions([
      "getContracts",
      "getCompanies",
      "postSearchContrat",
      "getProducts",
      "getFiles"
    ]),
    initialize() {
      this.prospectdata = [];
    },
    showAllFillData() {
      this.initContracts();
      //alert(this.showAllFil);
    },
    getMonthNameFromDate(item) {
      
      const date = new Date(item);
      const monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
      const monthIndex = date.getMonth();
      // alert(monthNames[monthIndex])
      return monthNames[monthIndex];
    },
    closeForm() {
      this.contractModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    async makeSearchContract() {
      this.loading = true;

      try {
        const schema = {
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          policeNumber: this.policeNumber,
          plugged: this.plugged,
          receiptNumber: this.receiptNumber,
          periodStartDate: "",
          periodEndDate: "",
          company: this.company,
          primeRepaymentDateExist: "true",
          companyRepaymentDateExist: "true",
          primeRepaymentDateStart: this.primeRepaymentDateStart,
          primeRepaymentEndDate: this.primeRepaymentEndDate,
          companyRepaymentEndDate: this.companyRepaymentEndDate,
          companyRepaymentStartDate: this.companyRepaymentStartDate,
          paymentStartDate: this.startDate,
          paymentEndDate: this.endDate,
          paymentMethod: this.paymentMethod,
          notPayed: false,
          payed: true,
          netPrime: this.netPrimeSearch,
        };
        await this.postSearchContrat(schema);
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    async cleanOnEnter() {
      this.loading = true;
      this.startDate = ""
      this.endDate = ""
      this.fileName = ""
      this.product = ""
      this.policeNumber = ""
      this.primeRepaymentDateStart = ""
      this.primeRepaymentEndDate = ""
      this.plugged = ""
      this.receiptNumber = ""
      this.company = ""
      this.companyRepaymentStartDate = ""
      this.companyRepaymentEndDate = ""
      this.paymentMethod = ""
      this.netPrimeSearch = ""
      await this.getContracts({
        payed: true,
        withoutPeriod: this.showAllFil,
        primeRepaymentDateExist: "true",
        companyRepaymentDateExist: "true"
      });
      console.log(this.contractModal);
      this.selected = JSON.parse(localStorage.getItem("payementSelectData"))
      this.loading = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    applyEncaissementModal() {

      this.cancelDialog = true
      // alert(this.cancelDialog)
    },
    // Contracts
    async initContracts() {
      this.loading = true;
      this.selected = {};
      try {
        await this.getContracts({
          payed: true,
          withoutPeriod: this.showAllFil,
          primeRepaymentDateExist: "true",
          companyRepaymentDateExist: "true",
          sendToCommission: true
        });
        this.selected = JSON.parse(localStorage.getItem("payementSelectData"))
        await this.getCompanies();
        await this.getFiles({ withoutPeriod: true });
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    async innCash() {
      this.loading = true;
      try {
        //this.$refs.form.validate();

        for (let index = 0; index < this.selected.length; index++) {
          const element = this.selected[index];
          // alert(element)

          try {
            const schema = {
              collectionDate: this.contractModal.collectionDate,
              mailNumberOtherFile: this.contractModal.mailNumberOtherFile,
              paymentPaymentMethod: this.contractModal.paymentPaymentMethod,
              paymentCheckNumber: this.contractModal.paymentCheckNumber,
              paymentBank: this.contractModal.paymentBank,
            }
            if (element._id) {
              // alert(element._id)
              await updateContract({
                schema,
                id: element._id,
              });
            }
          }
          catch (error) {
            defaultMethods.dispatchError(this.$store);
          }

        }
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.closeContract();
        this.initContracts();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      finally {
        this.selected = {}
        window.localStorage.removeItem('payementSelectData');
        this.loading = false
      }
      // this.loading = false;
    },
    editItemFormat(item) {
      item = defaultMethods.arrayFieldsToInteger(item);

      this.contractModal.totalPrime = item.totalPrime;
      this.contractModal.netPrime = item.netPrime;
      this.contractModal.primeRC = item.primeRC;
      this.contractModal.cdeaoPrime = item.cdeaoPrime;
      this.contractModal.commission = item.commission;
      this.contractModal.companyNetPrime = item.companyNetPrime;
      this.contractModal.companyCommission = item.companyCommission;
      this.contractModal.accessory100 = item.accessory100;
      this.contractModal.accessory50 = item.accessory50;
    },
    editContractCollection(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.contractModal.name = item.file.name;
      this.contractModal.company = item.company.name;
      this.contractModal.primeRC = item.primeRC;
      this.contractDialog = true;
    },
    editFactureCollection(item) {
      this.contractModal = Object.assign({}, item);
      this.contractModal.amount = "";
      this.editItemFormat(item);
      this.contractModal.name = item.file.name;
      this.contractModal.company = item.company.name;

      this.factureDialog = true;
    },
    handleClickMailGed(item) {
      // alert(JSON.stringify(item))
      this.filesListe = item.reversements_files;
      this.addFileMailGed = true;
    },
    handleClickMailGedQuitance(item) {
      this.filesListeQuitance = item.quittances_files;
      this.addFileMailGedQuittance = true;
    },
    handleClickMailGedPayement(item) {
      this.filesListePayement = item.payements_files;
      this.addFileMailGedPayement = true;
    },
    handleClickMailGedPayementPreuve(item) {
      // alert(JSON.stringify(item.mailNumberOtherFile))
      this.filesListePayementPreuve = item.others_files;
      this.addFileMailGedPayementPreuveData = true;
    },
    async saveProspect() {
      this.loading = true;
      try {
        if (this.contractModal._id) {
          // updat
          await updateFile({
            schema: {
              name: this.contractModal.name,
              prospects: this.contractModal.prospects,
              phone: this.contractModal.phone,
              email: this.contractModal.email,
              nature: this.contractModal.nature,
              location: this.contractModal.location,
              description: this.contractModal.description,
              activityField: this.contractModal.activityField,
              birthday: this.contractModal.birthday,
              // proposedProducts: this.contractModal.proposedProducts,
            },
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeForm();
          this.initContracts();
        } else {
          // add
          await addFile(this.contractModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          this.closeForm();
          this.initContracts();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async invoiceAdd() {
      this.loading = true;
      try {
        const schema = {
          commission: this.contractModal.commission,
          netPrime: this.contractModal.netPrime,
          totalPrime: this.contractModal.totalPrime,
          TE: this.contractModal.cdeaoPrime,
          TACAVA: this.contractModal.TACAVA,
          TVA: this.contractModal.TVA,
          contract: this.contractModal._id,
        };

        //  update
        await addInvoice({
          schema,
          id: this.contractModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.closeContract();
        this.initContracts();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    async cashIn() {
      this.loading = true;
      try {
        const schema = {
          // name: this.contractModal.name,Companies
          policeNumber: this.contractModal.policeNumber,
          //receiptNumber: this.contractModal.receiptNumber,
          product: this.contractModal.product,
          category: this.contractModal.category,
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          netPrime: this.contractModal.netPrime,
          commission: this.contractModal.commission,
          primeRC: Number(this.contractModal.primeRC),
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          mailNumberOtherFile: this.contractModal.mailNumberOtherFile,
          // emissionNumber: this.contractModal.emissionNumber,
          invoiceNumber: this.contractModal.invoiceNumber,
          paymentPaymentMethod: this.contractModal.paymentPaymentMethod,
          paymentCheckNumber: this.contractModal.paymentCheckNumber,
          paymentBank: this.contractModal.paymentBank,
          // paymentMethod: this.contractModal.paymentMethod,
          companyNetPrime: this.contractModal.companyNetPrime,
          companyCommission: this.contractModal.companyCommission,
          collectionDate: this.contractModal.collectionDate,
          fromPayment: true,
          // variationCommission: this.contractModal.variationCommission,
          netPrimeObservation: this.contractModal.netPrimeObservation,
          commissionObservation: this.contractModal.commissionObservation,
          transferObservation: this.contractModal.transferObservation,
          paymentObservation: this.contractModal.paymentObservation,
        };

        //  update
        await updateContract({
          schema,
          id: this.contractModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.closeContract();
        this.initContracts();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.contractModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),

          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        //  update
        await updateContract({
          schema,
          id: this.contractModal._id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Contract")
        );
        this.closeContract();
        this.initContracts();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeContract() {
      this.contractDialog = false;
      this.factureDialog = false;
      this.fileDialog = false;
      this.cancelDialog = false;
      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
    },
    addProspect() {
      this.editedIndex = -1;
      this.contractModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    editContract(item) {
      this.editedIndex = 1;
      this.contractModal = Object.assign({}, item);

      this.contractModal.company = defaultMethods.getItemName(
        this.Companies.docs,
        this.contractModal.company
      );
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.contractModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.contractModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.contractModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.contractModal);
      } else {
        this.prospectdata.push(this.contractModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
